import React, { useState, useEffect } from 'react';
import GalleryCategories from '../components/GalleryCategories';
import Gallery from '../components/Gallery';

export default function GalleryPage({ language }) {
  const [showCategories, setShowCategories] = useState(() => !window.location.hash);
  useEffect(() => {
    function onHashChange() {
      setShowCategories(!window.location.hash);
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return showCategories
    ? <GalleryCategories language={language} />
    : <Gallery language={language} />;
}

